import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { frequencyType, sampleType } from "../../../utilities/constants/WaterSystemConstants";
import { GET_OTHER_DISTRIBUTION_MONITORING } from "../../../queries/archiveQrys/MonitoringScheduleReportQueries";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const OtherDistributionMonitoringTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: "Analyte Name",
      accessor: "analyteName",
      width: 150
    },
    {
      Header: "ID",
      accessor: "facilityCode",
      width: 75
    },
    {
      Header: "Samples Required",
      accessor: "sampleCount"
    },
    {
      Header: "Type",
      width: 75,
      accessor: (d) => {
        return d.sampleType ? sampleType[d.sampleType] : "";
      }
    },
    {
      Header: "Frequency",
      width: 100,
      accessor: (d) => {
        return d.sampleFrequency ? frequencyType[d.sampleFrequency] : "";
      }
    },
    {
      Header: "Last Sampled",
      width: 100,
      accessor: (d) => {
        return d.lastSampleDate ? convertTimeStampToDate(d.lastSampleDate) : "";
      }
    },
    {
      Header: "Next Sample Due",
      accessor: "nextSampleDateRange"
    }
  ];

  const { loading, error, data } = useQuery(GET_OTHER_DISTRIBUTION_MONITORING, { variables: { systemId } });

  if (loading) return <SkeletonLoader width='100%'/>;
  if(error) return <ErrorHandler error={error} />;

  let array = [];
  if (data.getPublicOtherDistributionMonitoringPbcu !== null) {
    array.push(data.getPublicOtherDistributionMonitoringPbcu);
  }
  if (data.getPublicOtherDistributionMonitoringAsbestos !== null) {
    array.push(data.getPublicOtherDistributionMonitoringAsbestos);
  }

  return (
    <>
      {array.length > 0 ? (
        <DtsReactTable data={array} columns={columns} headerColor='ddw' cypressid="pcbuTable"/>
      ) : (
        <span>No Other Distribution Monitoring was found in the database.</span>
      )}
    </>
  );
};

export default OtherDistributionMonitoringTable;
